<template>
  <div am-edit-modal-item am-checkbox-item>
    <i-checkbox :modelValue="checked" @update:modelValue="select" />
  </div>
</template>

<script>
import { mapMutations } from 'vuex'

export default {
  name: 'CheckboxItem',
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  computed: {
    checked () {
      return !!this.data.data && this.data.data !== '0'
    }
  },
  methods: {
    ...mapMutations('parts', ['SET_CHANGED_PARTS']),
    select (value) {
      this.$store.state.parts.data[this.$route.params.subtable].parts[this.data.index].data = value
      this.SET_CHANGED_PARTS({ subtable: this.$route.params.subtable, data: this.data })
    }
  }
}
</script>

<style lang="scss">
[am-edit-modal-item][am-checkbox-item] {
  .checkbox {
    margin: 0;
    .checkbox-label {
      cursor: pointer;
      &::before {
        min-width: var(----size);
        min-height: var(----size);
        border-color: var(----border-color--checked);
      }
    }
  }
}
</style>
